import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  Container,
  useScrollTrigger,
  Slide,
  useTheme,
  alpha,
  Typography,
} from "@mui/material";
import { LogoIcon } from "../../layout/fullLayout/logo/Logo";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";

interface Props {
  window?: () => Window;
  children: React.ReactElement;
}

function HideOnScroll(props: Props) {
  const { children, window } = props;
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
  });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export interface NavProps {
  pageType?: "LOGIN" | "SIGNUP" | "LOGOUT";
  /** Optional accent color for the action button (defaults to theme primary). */
  accentColor?: string;
  accentHoverColor?: string;
}

const Navbar = (props: NavProps) => {
  const { pageType, accentColor, accentHoverColor } = props;
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const theme = useTheme();

  const actionBtnSx = {
    borderRadius: "8px",
    fontWeight: 600,
    textTransform: "none" as const,
    px: 3,
    py: 1,
    boxShadow: "none",
    ...(accentColor
      ? {
        backgroundColor: accentColor,
        "&:hover": {
          boxShadow: "none",
          backgroundColor: accentHoverColor || accentColor,
        },
      }
      : {
        "&:hover": {
          boxShadow: "none",
          backgroundColor: theme.palette.primary.dark,
        },
      }),
  };

  return (
    <HideOnScroll>
      <AppBar
        id="sign-up-navbar"
        position="fixed"
        sx={{
          backgroundColor: theme.palette.background.paper,
          boxShadow: "0px 1px 10px rgba(0, 0, 0, 0.05)",

          backdropFilter: "blur(8px)",
          background: alpha(theme.palette.background.paper, 0.8),
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <LogoIcon isNavbar={true} />
               */}
              <LogoIcon />
            </Box>

            {pageType !== "LOGOUT" ? <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography>
                {pageType === "SIGNUP"
                  ? "Already have an Account?"
                  : pageType === "LOGIN"
                    ? "Don't have an Account?"
                    : `Welcome ${user.name}`}
              </Typography>

              {pageType === "SIGNUP" ? (
                <Button
                  variant="contained"
                  sx={actionBtnSx}
                  onClick={() => navigate("/auth/login")}
                >
                  Login
                </Button>
              ) : pageType === "LOGIN" ? (
                <Button
                  variant="contained"
                  sx={actionBtnSx}
                  onClick={() => navigate("/auth/signup")}
                >
                  Sign Up
                </Button>
              ) : (
                <></>
              )}
            </Box>
              : (
                <Button
                  variant="contained"
                  sx={actionBtnSx}
                  onClick={logout}
                >
                  Logout
                </Button>
              )}
          </Toolbar>
        </Container>
      </AppBar>
    </HideOnScroll>
  );
};

export default Navbar;
